var $a146d231f9c4bbf9$exports = {};
$a146d231f9c4bbf9$exports = {
    "longPressMessage": `\u{9577}\u{6309}\u{6216}\u{6309} Alt+\u{5411}\u{4E0B}\u{9375}\u{4EE5}\u{958B}\u{555F}\u{529F}\u{80FD}\u{8868}`
};


export {$a146d231f9c4bbf9$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
